import React from 'react';

import * as messages from '@radnuc/messages';
import * as d3 from 'd3';
import strong_lines_list from '@radnuc/react-ui-components/dist/spectrum_strong_lines_RFG';
import { Dataset, Device, PlottableSensorReading, GPSReading, METReading, PlottableSensorTypes } from '../BD21Device'
import { ConvertSensorNameToMakeModel, IsPlottableNode, NodeHealthData } from '../NodeHealth';

import add_icon from './img/add_circle_icon.png'
import remove_icon from './img/circle_remove_icon.png'

import '@radnuc/react-ui-components/dist/SpectrumDisplay.css'
import './BioCountPlotDisplay.css'

//Count Display Button
import cound_display_logo from './img/graph_white_48px.png'
import '@radnuc/react-ui-components/dist/MapDisplay.css'



export interface DeviceInterface {
    select: (key: {device:string,sensor:string,follow:boolean}) => void,
    unselect: () => void,
    setPlotVisibility: (flag:boolean) => void,
    plotVisibility: boolean,
}

export interface BioCountDisplayProps {
    plotIndex: string,
    bioData: PlottableSensorReading[] | null | undefined,
    liveStream?: boolean,
    replayTime?: Date,
    plotSelectInterface?: PlotSelectInterface,
    plot_time_range?: {min:number,max:number};
}

export interface BioCountDisplayState {
    //plotTimeRange: [number, number] | undefined
    //liveSpectrumSumStartTime: number
}

export class BioCountPlotDisplay extends React.Component<BioCountDisplayProps> {

    timestamps: number[];
    bioCounts: PlottableSensorReading[];
    min_channel_rate: number = 5e-3;
    lastTimeForceRedraw: number = 0;

    constructor(props: BioCountDisplayProps) {
        super(props)
        this.bioCounts = [];
        this.timestamps = []
    }

    componentDidUpdate(prevProps: BioCountDisplayProps) {
        //if (this.props.radiationData !== prevProps.radiationData) {
        //}
    }

    addVector(a: number[], b: number[] | null) {
        if (b !== null)
            return a.map((e, i) => e + b[i]);
        else
            return a;
    }

    render() {

        let thisBioData:PlottableSensorReading[] | null = null;
        if(this.props.bioData === undefined){
            thisBioData = null;
        } else {
            thisBioData = this.props.bioData;
        }
        return (
            <>
                <BioCountHistoryPlot plotIndex={this.props.plotIndex} data={thisBioData} plot_time_range={this.props.plot_time_range} replayTime={this.props.replayTime} liveStream={this.props.liveStream} plotSelectInterface={this.props.plotSelectInterface}/>
            </>
        );
    }

}
export default BioCountPlotDisplay

//******************************************************************************
export interface BioCountHistoryPlotProps {
    plotIndex: string,
    data: PlottableSensorReading[] | null,
    replayTime?: Date,
    liveStream?: boolean,
    plotSelectInterface?: PlotSelectInterface,
    plot_time_range?: {min:number,max:number}
    //onSelectRange: (start_time: number | null, end_time: number | null) => void;
    //setStartTime: (start_time: number) => void;
}

export class BioCountHistoryPlot extends React.Component<BioCountHistoryPlotProps> {
    base: HTMLDivElement | null
    updateRef: (element: HTMLDivElement) => void
    previous_brush: [number, number] | undefined;

    plot_margin = { top: 10, right: 50, bottom: 18, left: 55 };
    plot1_x: d3.ScaleTime<number, number> | null = null;
    plot1_y: d3.ScaleContinuousNumeric<number, number> | null = null;
    plot1_g: any | null
    plot2_x: d3.ScaleTime<number, number> | null = null;
    plot2_y: d3.ScaleContinuousNumeric<number, number> | null = null;
    plot2_g: any | null
    count_rate_width: number = 0
    count_rate_height: number = 0
    source_brush: d3.BrushBehavior<unknown> | null = null;
    brush_path: any;
    history_plot_range_msec = 120000;
    plot1_scale_min = 50; //cps
    plot2_scale_min = 50; //cps
    plot_total_counts: boolean =false;

    constructor(props: BioCountHistoryPlotProps) {
        super(props)
        this.base = null

        this.resize = this.resize.bind(this);

        this.updateRef = (element: HTMLDivElement) => {
            this.base = element;
            this.renderPlot();
        };
    }

    componentDidMount() {
        this.initPlot()
        this.renderPlot();
        window.addEventListener("resize", this.resize);
    }

    componentDidUpdate(prevProps: BioCountHistoryPlotProps) {
        //Redraw if data changed
        if (this.props.data !== prevProps.data) {
            this.renderPlot();
        }
        if (this.props.replayTime !== prevProps.replayTime) {
            this.renderPlot();
        }
        //Redraw if ganged plot range changed
        if(this.props.plot_time_range !== undefined && prevProps.plot_time_range !== undefined){
            if(this.props.plot_time_range.max > prevProps.plot_time_range.max){
                this.renderPlot();
            }
        }
        if(this.props.plotSelectInterface !== undefined && prevProps.plotSelectInterface !== undefined){
            if(this.props.plotSelectInterface.selectedDevices !== prevProps.plotSelectInterface.selectedDevices){
                this.resize();
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize() {
        this.initPlot()
        this.renderPlot();
    }

/*
    on_source_brush() {
        if (this.plot1_x !== null && this.plot1_y !== null) {
            var sel = d3.event.selection || this.plot1_x.range();
            var times = sel.map(this.plot1_x.invert, this.plot1_x);
            times[0] = Math.round(times[0] / 1000) * 1000;
            times[1] = Math.round(times[1] / 1000) * 1000;
            if (d3.event.selection !== null) {
                if (this.previous_brush === undefined) {
                    this.props.onSelectRange(times[0], times[1])
                    this.previous_brush = times;
                } else {
                    if (this.previous_brush[0] !== times[0] || this.previous_brush[1] !== times[1]) {
                        this.props.onSelectRange(times[0], times[1])
                        this.previous_brush = times;
                    }
                }
            } else {
                if (this.previous_brush !== undefined) {
                    this.props.onSelectRange(null, null);
                    this.previous_brush = undefined;
                    if (this.source_brush !== null)
                        this.brush_path.call(this.source_brush.move, null);
                }
            }
        }
    }
*/
    initPlot() {
        if(this.base !== null) {
            const width = this.base.clientWidth -10;//- 20;  // subtract 20 to compensate for margins
            const height = this.base!.clientHeight - 10;

            this.count_rate_width = width -
                this.plot_margin.left - this.plot_margin.right;
            this.count_rate_height = height -
                this.plot_margin.top - this.plot_margin.bottom;

            d3.select(this.base!).select("svg").remove();

            const count_rate_svg = d3.select(this.base!).append("svg")
                .attr("width", `${width}px`)
                .attr("height", `${height}px`);

            //Small Particle Count Plot
            this.plot2_g = count_rate_svg.append('g').attr(
                'transform', 'translate(' + this.plot_margin.left + ',' +
                this.plot_margin.top + ')');

            this.plot2_g.selectAll('.neutron-plot-axis').remove();
            this.plot2_g.selectAll('path').remove();

            this.plot2_x =
                d3.scaleTime().rangeRound([0, this.count_rate_width]);
            this.plot2_y =
                d3.scaleLinear().rangeRound([this.count_rate_height,0]);

            //Large Particle Count Plot
            this.plot1_g = count_rate_svg.append('g').attr(
                'transform', 'translate(' + this.plot_margin.left + ',' +
                this.plot_margin.top + ')');

            this.plot1_g.selectAll('.plot-axis').remove();
            this.plot1_g.selectAll('path').remove();

            this.plot1_x =
                d3.scaleTime().rangeRound([0, this.count_rate_width]);
            this.plot1_y =
                d3.scaleLinear().rangeRound([this.count_rate_height, 0]);
            /*
            this.source_brush =
                d3.brushX().on('brush end', this.on_source_brush.bind(this));

            this.brush_path = this.plot1_g.append('g')
                .attr('class', 'brush')
                .call(this.source_brush);
            */
        }
    }

    getTitleString(selectedPlotDataType:string){
        let title = 'Plot';
        if(this.props.data !== null && this.props.data.length > 0){
            if(this.props.data[0].sensor_type === PlottableSensorTypes.IBAC){
                title = this.props.data[0].getTitleStringFromName(selectedPlotDataType)
            } else if(this.props.data[0].sensor_type === PlottableSensorTypes.TAC7){
                title = this.props.data[0].getTitleStringFromName(selectedPlotDataType)
            } else if(this.props.data[0].sensor_type === PlottableSensorTypes.TACBIO){
                title = this.props.data[0].getTitleStringFromName(selectedPlotDataType)
            } else if(this.props.data[0].sensor_type === PlottableSensorTypes.MET){
                title = this.props.data[0].getTitleStringFromName(selectedPlotDataType)
            } else if(this.props.data[0].sensor_type === PlottableSensorTypes.ADAv3){
                title = this.props.data[0].getTitleStringFromName(selectedPlotDataType)
            } else if(this.props.data[0].sensor_type === PlottableSensorTypes.ADAv5a){
                title = this.props.data[0].getTitleStringFromName(selectedPlotDataType)
            } else if(this.props.data[0].sensor_type === PlottableSensorTypes.ADAv5b){
                title = this.props.data[0].getTitleStringFromName(selectedPlotDataType)
            } else if(this.props.data[0].sensor_type === PlottableSensorTypes.CBSIGMA){
                title = this.props.data[0].getTitleStringFromName(selectedPlotDataType)
            }
        }
        return title;
    }

    renderPlot() {
        if (this.plot1_x !== null && this.plot1_y !== null && this.plot2_x !== null && this.plot2_y !== null) {
            let max_all_x = 0;
            let min_plot_x = 0;

            if(this.props.data !== null){
                if(this.props.data.length > 0){
                    //Gamma data only
                    if(this.props.plot_time_range !== undefined){
                        //Specified
                        this.plot1_x.domain([
                            this.props.plot_time_range.min,
                            this.props.plot_time_range.max
                        ]);
                        min_plot_x = this.props.plot_time_range.min;
                    } else {
                        //From data
                        this.plot1_x.domain([
                            d3.min(this.props.data, function (d) { return d.timestamp }) || 0,
                            d3.max(this.props.data, function (d) { return d.timestamp }) || 0
                        ]);
                        min_plot_x = d3.min(this.props.data, function (d) { return d.timestamp }) || 0;
                    }
                    this.plot2_x = this.plot1_x;
                } else {
                    //NO VALID DATA

                }
            }
            //this.props.setStartTime(min_plot_x);

            //Y axis limits
            var plot1_maxval_y = 0;
            var plot1_minval_y = 100000;

            if(this.props.data !== null){
                let sorted_data = [...this.props.data].sort((a,b)=>{return a.timestamp - b.timestamp});

                //Plot 1 Data
                let selectedPlot1DataType='';
                if(this.props.plotSelectInterface?.selectedDevices[this.props.plotIndex] !== undefined)
                    selectedPlot1DataType = this.props.plotSelectInterface?.selectedDevices[this.props.plotIndex].plot1Displayed;
                let plot1_scale_min = 50;
                let plot1_title_string = '';
                let validPlot1Data;
                if(this.props.plotSelectInterface !== undefined){
                    plot1_title_string = this.getTitleString(selectedPlot1DataType!);
                    let plot1_auto_min_x = 1e20;
                    if(plot1_title_string !== 'Plot'){
                        validPlot1Data = this.props.data.filter(function (d:any) {
                            plot1_scale_min = d.getMinScaleFromName(selectedPlot1DataType);

                            //Data dependent scaling
                            if(plot1_scale_min === -99999){
                                //Auto scale to data
                                if((d.sensor_type === PlottableSensorTypes.ADAv3 && selectedPlot1DataType === 'Confidence') ||
                                   (d.sensor_type === PlottableSensorTypes.ADAv5a && selectedPlot1DataType === 'Confidence') ||
                                   (d.sensor_type === PlottableSensorTypes.ADAv5b && selectedPlot1DataType === 'Confidence') ){
                                    if(d.confidence < plot1_auto_min_x){
                                        plot1_auto_min_x = d.confidence;
                                        plot1_scale_min = plot1_auto_min_x;
                                    }
                                }
                            }

                            return d.getDataFromName(selectedPlot1DataType) !== null
                        }).filter(function (d) { return d.timestamp >= min_plot_x});
                    }
                } else {
                    validPlot1Data = this.props.data.filter(function (d) { return d.bio_particle_count !== null }).filter(function (d) { return d.timestamp >= min_plot_x});;
                }

                let plot1_yaxis_label_decimal = 0;
                if(validPlot1Data !== undefined){
                //Find min and max of data
                const minValidPlot1Data = d3.min(validPlot1Data, function (d) { return d.getDataFromName(selectedPlot1DataType!)}) || 0;
                const maxValidPlot1Data = d3.max(validPlot1Data, function (d) { return d.getDataFromName(selectedPlot1DataType!)}) || 0;

                this.plot1_y.domain([
                    minValidPlot1Data,
                    maxValidPlot1Data
                ]);

                //Find max and min of Plot 1
                if(this.plot1_y.domain()[1] > plot1_maxval_y){
                    plot1_maxval_y = this.plot1_y.domain()[1];
                }
                if(this.plot1_y.domain()[0] < plot1_minval_y){
                    plot1_minval_y = this.plot1_y.domain()[0];
                }

                //Plot Customization
                //let plot1_yaxis_label_decimal = 0;
                let plot1_yaxis_floor = null;
                if(validPlot1Data.length > 0){
                    plot1_yaxis_label_decimal = validPlot1Data[0].getLabelDecimalPlace(selectedPlot1DataType!);
                    plot1_yaxis_floor = validPlot1Data[0].getYAxisFloor(selectedPlot1DataType!);
                }
                if(plot1_yaxis_floor !== null){
                    plot1_minval_y = plot1_yaxis_floor;
                };


                //Set range for plots
                if (plot1_maxval_y < plot1_scale_min){
                    this.plot1_y.domain([plot1_minval_y,plot1_scale_min]);
                } else {
                    //this.plot1_y.domain([gamma_minval_y,gamma_maxval_y]);
                }


                let plot1_xscale = this.plot1_x;
                let plot1_yscale = this.plot1_y;

                // clang-format off
                this.plot1_g.selectAll('.plot-axis').remove();
                this.plot1_g.selectAll('.replay-time').remove();
                this.plot1_g.selectAll('path').remove();
                this.plot1_g.selectAll('line').remove();
                this.plot2_g.selectAll('.neutron-plot-axis').remove();
                this.plot2_g.selectAll('path').remove();
                this.plot2_g.selectAll('line').remove();

                //Plot 1
                this.plot1_g.append('g')
                    .attr('class', 'plot-axis')
                    .attr('transform', 'translate(0,' + this.count_rate_height + ')')
                    .call(d3.axisBottom(plot1_xscale).scale(plot1_xscale).ticks(7))

                this.plot1_g.append('g')
                    .attr('class', 'plot-axis')
                    .call(d3.axisLeft(plot1_yscale).ticks(7).tickFormat(y => `${y.valueOf().toFixed(plot1_yaxis_label_decimal)}`));

                this.plot1_g.append('g')
                    .attr('class', 'plot-axis')
                    .append("text")

                    // this makes it easy to centre the text as the transform is applied to the anchor
                    .attr("text-anchor", "middle")

                    // text is drawn off the screen top left, move down and out and rotate
                    .attr("transform", "translate(-" + this.plot_margin.left * 0.7 + "," +
                        (this.count_rate_height / 2) + ")rotate(-90)")

                    .attr("fill", 'limegreen')
                    .text(plot1_title_string);


                this.plot1_g.append('path')
                    .datum(validPlot1Data) //was sorted_data
                    .attr('fill', 'none')
                    .attr('stroke', 'LimeGreen')
                    .attr('stroke-width', 1.5)
                    .attr('d', d3.line()
                        .x(function (d: any) { return plot1_xscale(d.timestamp) as number})
                        .defined(function (d: any) {
                            //return d.particleLargeBio !== null;
                            //if(d.constructor.name === 'IBACReading'){
                                const out = d.getDataFromName(selectedPlot1DataType)
                                if (out !== undefined && out !== null){
                                    return out
                                } else return false

                            //} else {
                            //    return 0
                            //}
                        })
                        .defined(function (d: any) { return d.timestamp > min_plot_x; })
                        .y(function (d: any) {
                            //return yscale(d.particleLargeBio) as number
                            //if(d.constructor.name === 'IBACReading'){
                                const out = d.getDataFromName(selectedPlot1DataType)
                                if(out !== undefined)
                                    return plot1_yscale(out) as number
                                else
                                    return 0 as number;
                        })
                    );

                    if (this.props.replayTime && !this.props.liveStream) {
                        var pos = this.plot1_x(this.props.replayTime);
                        if (pos === undefined)
                            pos = 0;
                        if (pos < 0)
                            pos = 0;
                        if (pos > this.count_rate_width)
                            pos = this.count_rate_width;

                        this.plot1_g.append("line")
                            .attr('class', 'replay-time')
                            .attr("x1", pos)
                            .attr("y1", 0)
                            .attr("x2", pos)
                            .attr("y2", this.count_rate_height)
                            .style("stroke-width", 2)
                            .style("stroke", "red")
                            .style("fill", "none");
                    }

                } else {
                    //No data Plot 1
                    this.plot1_g.append('g')
                        .attr('class', 'plot-axis')
                        .call(d3.axisLeft(this.plot1_y).ticks(0));

                    this.plot1_g.append('g')
                        .attr('class', 'plot-axis')
                        .attr('transform', 'translate(0,' + this.count_rate_height + ')')
                        .call(d3.axisBottom(this.plot1_x).scale(this.plot1_x).ticks(0))
                }

                //Plot 2
                //Y axis limits
                var plot2_maxval_y = 0;
                var plot2_minval_y = 100000;
                //Plot 2 Data
                let selectedPlot2DataType='';
                if (this.props.plotSelectInterface?.selectedDevices[this.props.plotIndex] !== undefined)
                    selectedPlot2DataType = this.props.plotSelectInterface?.selectedDevices[this.props.plotIndex].plot2Displayed;
                let plot2_scale_min = 50;
                let plot2_auto_min_x = 1e20;
                let plot2_title_string = '';
                let validPlot2Data;
                if(this.props.plotSelectInterface !== undefined){
                    plot2_title_string = this.getTitleString(selectedPlot2DataType!);
                    if(plot2_title_string!=='Plot'){
                        validPlot2Data = this.props.data.filter(function (d:any) {
                            plot2_scale_min = d.getMinScaleFromName(selectedPlot2DataType);

                            if(plot2_scale_min === -99999){
                                //Auto scale to data
                                if((d.sensor_type === PlottableSensorTypes.ADAv3 && selectedPlot1DataType === 'Confidence') ||
                                   (d.sensor_type === PlottableSensorTypes.ADAv5a && selectedPlot1DataType === 'Confidence') ||
                                   (d.sensor_type === PlottableSensorTypes.ADAv5b && selectedPlot1DataType === 'Confidence') ){
                                    if(d.confidence < plot2_auto_min_x){
                                        plot2_auto_min_x = d.confidence;
                                        plot2_scale_min = plot2_auto_min_x;
                                    }
                                }
                            }
                            return d.getDataFromName(selectedPlot2DataType) !== null
                        }).filter(function (d) { return d.timestamp >= min_plot_x});
                    }

                } else {
                    validPlot2Data = this.props.data.filter(function (d) { return d.bio_particle_count !== null }).filter(function (d) { return d.timestamp >= min_plot_x});;
                }

                let plot2_yaxis_label_decimal = 0;
                if(validPlot2Data !== undefined){
                    //Data exists
                    //Find min and max of data
                    const minValidPlot2Data = d3.min(validPlot2Data, function (d) { return d.getDataFromName(selectedPlot2DataType!)}) || 0;
                    const maxValidPlot2Data = d3.max(validPlot2Data, function (d) { return d.getDataFromName(selectedPlot2DataType!)}) || 0;

                    this.plot2_y.domain([
                        minValidPlot2Data,
                        maxValidPlot2Data
                    ]);

                    //Find max and min of Plot 1
                    if(this.plot2_y.domain()[1] > plot2_maxval_y){
                        plot2_maxval_y = this.plot2_y.domain()[1];
                    }
                    if(this.plot2_y.domain()[0] < plot2_minval_y){
                        plot2_minval_y = this.plot2_y.domain()[0];
                    }

                    //Plot customization
                    //let plot2_yaxis_label_decimal = 0;
                    let plot2_yaxis_floor = null;
                    if(validPlot2Data.length > 0){
                        plot2_yaxis_label_decimal = validPlot2Data[0].getLabelDecimalPlace(selectedPlot2DataType!);
                        plot2_yaxis_floor = validPlot2Data[0].getYAxisFloor(selectedPlot2DataType!);
                    }
                    if(plot2_yaxis_floor !== null){
                        plot2_minval_y = plot2_yaxis_floor;
                    };

                    //Set range for plots
                    if (plot2_maxval_y < plot2_scale_min){
                        this.plot2_y.domain([plot2_minval_y,plot2_scale_min]);
                    } else {
                        //this.plot1_y.domain([gamma_minval_y,gamma_maxval_y]);
                    }

                    var plot2_xscale = this.plot2_x;
                    var plot2_yscale = this.plot2_y;

                    this.plot1_g.append('g')
                        .attr('class', 'plot-axis')
                        .attr('transform', 'translate(0,' + this.count_rate_height + ')')
                        .call(d3.axisBottom(plot2_xscale).scale(plot2_xscale).ticks(7))

                    this.plot2_g.append('g')
                        .attr('class', 'neutron-plot-axis')
                        .attr('transform', 'translate('+ this.count_rate_width + ',0)')
                        .call(d3.axisRight(plot2_yscale).ticks(7).tickFormat(y => `${y.valueOf().toFixed(plot2_yaxis_label_decimal)}`));

                    this.plot2_g.append('g')
                        .attr('class', 'neutron-plot-axis')
                        .append("text")
                        .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
                        .attr("transform", "translate("+ (this.count_rate_width+this.plot_margin.right*0.7) +","+(this.count_rate_height/2)+")rotate(90)")  // text is drawn off the screen top left, move down and out and rotate
                        .attr("fill",'steelblue')
                        .text(plot2_title_string);

                    this.plot2_g.append('path')
                        .datum(validPlot2Data) //was sorted_data
                        .attr('fill', 'none')
                        .attr('stroke', 'steelblue')
                        .attr('stroke-width', 1.5)
                        .attr('d', d3.line()
                            .x(function (d: any) { return plot2_xscale(d.timestamp) as number})
                            .defined(function (d: any) {
                                //return d.particleLargeBio !== null;
                                //if(d.constructor.name === 'IBACReading'){
                                    const out = d.getDataFromName(selectedPlot2DataType)
                                    if (out !== undefined && out !== null){
                                        return out
                                    } else return false
                            })
                            .defined(function (d: any) { return d.timestamp > min_plot_x; })
                            .y(function (d: any) {
                                //return yscale(d.particleLargeBio) as number
                                //if(d.constructor.name === 'IBACReading'){
                                    const out = d.getDataFromName(selectedPlot2DataType)
                                    if(out !== undefined)
                                        return plot2_yscale(out) as number
                                    else
                                        return 0 as number;
                            })
                        );
                        if (this.props.replayTime && !this.props.liveStream) {
                            var pos = this.plot2_x(this.props.replayTime);
                            if (pos === undefined)
                                pos = 0;
                            if (pos < 0)
                                pos = 0;
                            if (pos > this.count_rate_width)
                                pos = this.count_rate_width;

                            this.plot2_g.append("line")
                                .attr('class', 'replay-time')
                                .attr("x1", pos)
                                .attr("y1", 0)
                                .attr("x2", pos)
                                .attr("y2", this.count_rate_height)
                                .style("stroke-width", 2)
                                .style("stroke", "red")
                                .style("fill", "none");
                        }

                } else {
                    //No data plot 2
                    this.plot2_g.append('g')
                        .attr('class', 'neutron-plot-axis')
                        .attr('transform', 'translate('+ this.count_rate_width + ',0)')
                        .call(d3.axisRight(this.plot2_y).ticks(0));
                    this.plot1_g.append('g')
                        .attr('class', 'plot-axis')
                        .attr('transform', 'translate(0,' + this.count_rate_height + ')')
                        .call(d3.axisBottom(this.plot2_x).scale(this.plot2_x).ticks(0))
                }
            } else {
                //Data is null, clear and redraw
                this.initPlot();
            }

        }
    }

    render() {
        return (
            <div className="Plot" style={{ display: 'flex', flex: '1', flexDirection: 'column', backgroundColor:'#282828', margin:'0px',
                borderRadius: '0px', borderBottomLeftRadius:'5px', borderBottomRightRadius:'5px',height:'200px'}}>
                <div className="plot" ref={this.updateRef} style={{ display: 'flex', flex: '1', touchAction:'none' }} />
            </div>
        )
    }
}

//******************************************************************************

export interface BioCountDisplayButtonProps {
    devices:  { [key: string]: Device } | undefined,
    plotSelectInterface: PlotSelectInterface,
    deviceInterface?: DeviceInterface,
    selectedDeviceSensor?: {device:string, sensor:string} | null,
    liveStream?: boolean,
    replayTime?: Date,
    replayInvestigation?: string;
}

export interface BioCountDisplayButtonState {
    //plot_shown: boolean,
    follow_device_loc: boolean,
}

export class BioCountDisplayButton extends React.Component<BioCountDisplayButtonProps,BioCountDisplayButtonState> {

    deviceSensorToDisplay: {device:string, sensor:string} | undefined;

    constructor(props: BioCountDisplayButtonProps) {
        super(props)

        this.state = {
            //plot_shown: false,
            follow_device_loc: false,
        }

        this.handleCountDisplayButtonClick = this.handleCountDisplayButtonClick.bind(this);
        this.handleFollowDeviceLocClick = this.handleFollowDeviceLocClick.bind(this);
    }


    componentDidUpdate(prevProps: BioCountDisplayButtonProps) {
        if(this.props.replayInvestigation !== prevProps.replayInvestigation || this.props.liveStream !== prevProps.liveStream){

            if(prevProps.replayInvestigation !== undefined && this.props.replayInvestigation === undefined && prevProps.deviceInterface !== undefined){
                prevProps.deviceInterface.unselect();
            }

            if(this.props.selectedDeviceSensor !== undefined && this.props.selectedDeviceSensor !== null){
                this.deviceSensorToDisplay = {device:this.props.selectedDeviceSensor.device, sensor:this.props.selectedDeviceSensor.sensor};
            } else {
                this.deviceSensorToDisplay = undefined;
            }
        }
    }


    handleCountDisplayButtonClick(event: React.MouseEvent<HTMLElement>) {
        //this.setState(() => ({
        //    plot_shown: !this.state.plot_shown
        //}));
        if(this.props.deviceInterface !== undefined){
            this.props.deviceInterface.setPlotVisibility(!this.props.deviceInterface.plotVisibility);
        }
    }

    handleFollowDeviceLocClick() {
        this.setState(() => ({
            follow_device_loc: !this.state.follow_device_loc
        }));
        if(this.props.deviceInterface){
            if(!this.state.follow_device_loc){
                if(this.deviceSensorToDisplay === undefined){
                    this.props.deviceInterface.unselect();
                } else {
                    this.props.deviceInterface.select({device: this.deviceSensorToDisplay.device,
                                                        sensor: this.deviceSensorToDisplay.sensor,
                                                        follow: true});
                }
            } else {
                if(this.deviceSensorToDisplay === undefined){
                    this.props.deviceInterface.unselect();
                } else {
                    this.props.deviceInterface.select({device: this.deviceSensorToDisplay.device,
                                                        sensor: this.deviceSensorToDisplay.sensor,
                                                        follow: false});
                }
            }
        }
    }

    render(){

        /*
        if(this.props.devices !== undefined){
            if(this.props.selectedDevice !== undefined && this.props.selectedDevice !== null){
                this.deviceNameToDisplay = this.props.selectedDevice;
            } else if (this.deviceNameToDisplay === undefined){
                this.deviceNameToDisplay = Object.keys(this.props.devices)[0];
            }
        }
        */
        let device_sensor_map:{[deviceSensorName:string]:string} = {};
        Object.keys(this.props.plotSelectInterface.selectedDevices).forEach((plotKey) => {
            let deviceName = this.props.plotSelectInterface.selectedDevices[plotKey].deviceDisplayed
            let sensorName = this.props.plotSelectInterface.selectedDevices[plotKey].sensorDisplayed;
            device_sensor_map[(deviceName+'/'+sensorName)] = plotKey;
            if(this.deviceSensorToDisplay === undefined){
                this.deviceSensorToDisplay = {device:deviceName,sensor:sensorName};
            }
        });

        let bioDataToDisplay;

        if(this.deviceSensorToDisplay !== undefined){
            if(this.props.devices !== undefined && this.props.devices[this.deviceSensorToDisplay.device] !== undefined){
                if(this.props.devices[this.deviceSensorToDisplay.device].plottableSensorReadings !== undefined){
                    bioDataToDisplay = this.props.devices[this.deviceSensorToDisplay.device].plottableSensorReadings[ConvertSensorNameToMakeModel(this.deviceSensorToDisplay.sensor)];
                    if(bioDataToDisplay !== undefined){
                        //bioDataToDisplay = bioDataToDisplay['dummy'];
                    }
                }
            }
        }
        /*
        let default_value;
        if(this.deviceSensorToDisplay !== undefined){
            console.log(this.props.plotSelectInterface.selectedDevices[this.deviceSensorToDisplay.device])
            let deviceName = this.props.plotSelectInterface.selectedDevices[this.deviceSensorToDisplay.device].deviceDisplayed
            let sensorName = this.props.plotSelectInterface.selectedDevices[this.deviceSensorToDisplay.device].sensorDisplayed;
        //Object.values(this.state.displays).map((deviceName,index) => {
            if(Object.keys(this.props.devices).includes(deviceName)){
                bioDataToDisplay = this.props.devices[deviceName].plottableSensorReadings[sensorName]
            }

            default_value = this.deviceSensorToDisplay.device+' '+this.deviceSensorToDisplay.sensor;
        }
        */


        const bioCountDisplayButton =
                <div className="round-button" style={{ height: "48px", width:"48px", objectFit:'contain', padding: '5px' }} onClick={this.handleCountDisplayButtonClick}>
                    <img src={cound_display_logo} alt="Day/Night Toggle" />
                </div>

        let bioCountDisplay;
        //const devicesAvailable = Object.keys(this.props.devices)
        let followSelectClass = "";
        if(this.state.follow_device_loc){
            followSelectClass = "active";
        }
        /*
        const devicesAvailable = Object.keys(this.props.devices).map((mode) =>
            <option value={mode} key={mode}>{mode}</option>)
        */

        const devicesAvailable = Object.keys(device_sensor_map).map((mode) =>
            <option value={mode} key={mode}>{mode}</option>)

        let this_plotKey = '1';
        //if (this.state.plot_shown){
        if (this.props.deviceInterface !== undefined && this.props.deviceInterface.plotVisibility){
            if(this.props.liveStream){
                this_plotKey = device_sensor_map[this.deviceSensorToDisplay?.device+'/'+this.deviceSensorToDisplay?.sensor];
            } else {
                this_plotKey = device_sensor_map[this.deviceSensorToDisplay?.device+'/'+this.deviceSensorToDisplay?.sensor];
            }

            const followDeviceButton =
            <div className="icon-bar" style={{ paddingLeft: '10px', paddingBottom: '2px',position:'absolute'}}>
                <div className={"axis-type " + followSelectClass} onClick={() => {this.handleFollowDeviceLocClick()}}>TRACK LOCATION</div>
            </div>

            bioCountDisplay =
                <div style={{ position: "absolute", height: "227px", width:"350px",
                    overflow: 'hidden', zIndex:9998, right:'-136px', bottom:'62px',flex:'1', opacity:0.80 }}>
                    <div style={{flex:'1'}}>
                    <select className="modern" value={this.deviceSensorToDisplay?.device+'/'+this.deviceSensorToDisplay?.sensor}
                        onChange={(e) => {
                            const str = e.target.value.split('/');
                            this.deviceSensorToDisplay = {device:str[0],sensor:str[1]};
                            console.log('device/sensor to display: '+e.target.value)
                            if(this.props.deviceInterface){
                                if(this.state.follow_device_loc){
                                    //this.props.deviceInterface.select(this.deviceSensorToDisplay);
                                    this.props.deviceInterface.select({device: this.deviceSensorToDisplay.device,
                                                                        sensor: this.deviceSensorToDisplay.sensor,
                                                                        follow: true});
                                } else {
                                    this.props.deviceInterface.select({device: this.deviceSensorToDisplay.device,
                                                                        sensor: this.deviceSensorToDisplay.sensor,
                                                                        follow: false});
                                    //this.props.deviceInterface.unselect()
                                }
                            }
                        }}>
                        {devicesAvailable}
                    </select>
                    {/*followDeviceButton*/}

                    <BioCountPlotDisplay plotIndex={this_plotKey} bioData={bioDataToDisplay} liveStream={this.props.liveStream} replayTime={this.props.replayTime} plotSelectInterface={this.props.plotSelectInterface}/> //FIXME

                    </div>
                </div>
        }
        return(
            <>
                {bioCountDisplayButton}
                {bioCountDisplay}
            </>
        )
    }
}

//******************************************************************************
export interface MultiSensorBioCountDisplayProps {
    devices:  { [key: string]: Device } | undefined,
    plotSelectInterface: PlotSelectInterface,
    healthData: Map<string, NodeHealthData>,
    liveStream?: boolean,
    replayTime?: Date,
    replayInvestigation?: string;
}

/*
export interface MultiSensorBioCountDisplayState {
    //devicesDisplayed: {[key: number]: string},
    //sensorsDisplayed: {[key: number]: string},
    displays: {[key: string]: SensorDisplaySelection}
}
*/

export interface MultiSensorDisplaySelection {
    [key: string]: SensorDisplaySelection
}

export interface PlotSelectInterface {
    selectedDevices: MultiSensorDisplaySelection,
    update: (key: string, selection: SensorDisplaySelection) => void,
    remove: (key: string) => void,
    clear: () => void,
}

export interface SensorDisplaySelection {
    deviceDisplayed: string, //device === node
    sensorDisplayed: string,
    plot1Displayed: string,
    plot2Displayed: string,
    device_name: string,
    sensor_name: string,
    preload?: boolean,
    init?:boolean,
}

export class MultiSensorBioCountDisplay extends React.Component<MultiSensorBioCountDisplayProps> {

    originalSelectedDevices:MultiSensorDisplaySelection = {};
    constructor(props: MultiSensorBioCountDisplayProps) {

        super(props)
/*
        this.state = {
            //devicesDisplayed:{},
            //sensorsDisplayed:{},
            displays: {},
        }
*/
        this.addSensorDataPlot = this.addSensorDataPlot.bind(this);
        this.removeSensorDataPlot = this.removeSensorDataPlot.bind(this);
    }

    addSensorDataPlot() {
        const this_key = Date.now().toString();
        const updatedSensorDisplaySelection:SensorDisplaySelection  = {deviceDisplayed:'--',sensorDisplayed:'--',plot1Displayed:'--',plot2Displayed:'--',device_name:'',sensor_name:''}
        this.props.plotSelectInterface.update(this_key,updatedSensorDisplaySelection)
    }

    removeSensorDataPlot(plotkey:string){
        console.log(plotkey);
        this.props.plotSelectInterface.remove(plotkey);
    }

    componentDidUpdate(prevProps: MultiSensorBioCountDisplayProps) {
        if(this.props.liveStream !== undefined){
            if(this.props.liveStream){
                this.originalSelectedDevices = {};
                if(this.props.plotSelectInterface.selectedDevices !== prevProps.plotSelectInterface.selectedDevices){
                    console.log('selectedDevices updated')
                    this.forceUpdate();
                }
            } else {
                if(this.props.replayInvestigation !== prevProps.replayInvestigation){
                    //replay investigation has changed so reset
                    this.originalSelectedDevices = {};
                }
                if(Object.keys(this.originalSelectedDevices).length === 0 && Object.keys(this.props.plotSelectInterface.selectedDevices).length > 0){
                    this.originalSelectedDevices = {...this.props.plotSelectInterface.selectedDevices};
                    this.forceUpdate();
                }

            }
        }
    }

    render(){

        let plots: JSX.Element[] = [];
        if( Object.keys(this.props.plotSelectInterface.selectedDevices).length === 0 ){
            //No display
        //} else if(this.props.devices === undefined){
        //    //No ddta
        } else {

            //Get devicesAvailable from node health map
            let devicesAvailableLUT:{[key:string]:string} = {}
            this.props.healthData.forEach((val:NodeHealthData,key:string) => {
                devicesAvailableLUT[key]=val.raw_device_name;
            });
            const devicesAvailableString = Array.from(this.props.healthData.keys())
                .filter((thisDevice)=>{if(IsPlottableNode(thisDevice)){return true} else {return false}})
                .sort().sort((a, b) => {
                return String(a[0]).localeCompare(b[0]);
            });

            //Add device list from original list of seleced devices if replay
            if (!this.props.liveStream && Object.keys(this.originalSelectedDevices).length > 0){
                Object.keys(this.originalSelectedDevices).forEach(key => {
                    const thisDeviceDisplayed = this.originalSelectedDevices[key].deviceDisplayed;
                    if(!devicesAvailableString.find(el => {if(el.includes(thisDeviceDisplayed)) return true}))
                        devicesAvailableString.unshift(thisDeviceDisplayed);
                });
            }

            //Get devicesAvailable from data
            //let devicesAvailableString = Object.keys(this.props.devices).sort();

            //Add non-select if missing
            if(!devicesAvailableString.find(el => {if(el.includes('--')) return true}))
                devicesAvailableString.unshift('--');

            const devicesAvailable = devicesAvailableString.map((mode,idx) =>
                <option value={mode} key={mode+'_'+idx+'_devices'}>{mode}</option>)

            //Find newest timestamp in devices
            let plotTimeRange:{min:number,max:number} | undefined;
            let max_time=0;
            let min_time=1e20;
            let liveDataHistory=0;

            if(this.props.devices !== undefined){
                if(this.props.liveStream){
                    Object.values(this.props.devices).forEach((device) => {
                        if(device.time.getTime() > max_time){
                            max_time = device.time.getTime();
                            liveDataHistory = device.liveDataHistory;
                        }
                        if(device.time.getTime() < min_time){
                            min_time = device.time.getTime();
                        }
                    });
                } else {
                    Object.values(this.props.devices).forEach((device) => {
                        if(device.plottableSensorReadings !== undefined){
                            Object.values(device.plottableSensorReadings).forEach((sensor) => {
                                if(sensor !== undefined){
                                    sensor.forEach(reading => {
                                        if(reading.timestamp > max_time){
                                            max_time = reading.timestamp;
                                        }
                                        if(reading.timestamp < min_time){
                                            min_time = reading.timestamp;

                                        }
                                    });
                                }

                            });
                        }
                    });
                }
            }
            if(max_time > 0){
                plotTimeRange = {min:max_time-liveDataHistory, max:max_time};
            }
            if(!this.props.liveStream){
                //plotTimeRange = undefined;
                //N.B. PlotTimeRange needs to be ms
                if(min_time < 1e10)
                    min_time *= 1000;
                if(max_time < 1e10)
                    max_time *= 1000;
                plotTimeRange = {min:min_time, max:max_time};
            }

            Object.keys(this.props.plotSelectInterface.selectedDevices).forEach((plotKey,plotIdx) => {
                let deviceName = this.props.plotSelectInterface.selectedDevices[plotKey].deviceDisplayed
            //Object.values(this.state.displays).map((deviceName,index) => {
                let plot;
                let bioDataToDisplay;
                //console.log(this.props.devices)
                if(this.props.devices !== undefined){
                    if(Object.keys(this.props.devices).includes(deviceName)){
                        bioDataToDisplay = this.props.devices[deviceName].plottableSensorReadings
                    }
                }

                const selectNodeHeader =
                    <select className="modern-skinny" value={deviceName}
                        onChange={(e) => {
                            //this.deviceNameToDisplay = e.target.value;
                            console.log('changing index '+plotKey+' to '+e.target.value)
                            let thisSelectedDevice = JSON.parse(JSON.stringify(this.props.plotSelectInterface.selectedDevices[plotKey]));
                            thisSelectedDevice.deviceDisplayed = e.target.value;
                            thisSelectedDevice.sensorDisplayed = '--';
                            thisSelectedDevice.plot1Displayed = '--';
                            thisSelectedDevice.plot2Displayed = '--';
                            thisSelectedDevice.device_name = devicesAvailableLUT[e.target.value];
                            thisSelectedDevice.sensor_name = '';
                            this.props.plotSelectInterface.update(plotKey,thisSelectedDevice)
                        }}>
                        {devicesAvailable}
                    </select>

                let sensorsAvailableLUT:{[key:string]:string} = {}
                let sensorsAvailableString:string[] = []
                if(deviceName !== '--'){
                    //Get sensors available from node map
                    /*if(deviceName === 'NETWORK'){
                        const this_sensor = 'CBSIGMA';
                        const thisSensorString = 'PSI CBSIGMA';
                        const thisSensorNameString = 'PSI-CBSIGMA'
                        sensorsAvailableString.push(thisSensorString)
                        sensorsAvailableLUT[thisSensorString]=thisSensorNameString
                    } else */if(deviceName){
                        const this_node_health_sensors = this.props.healthData.get(deviceName);
                        if(this_node_health_sensors !== undefined){
                            Object.keys(this_node_health_sensors.sensors).forEach(sensor_key => {
                                const this_sensor = this_node_health_sensors.sensors[sensor_key];
                                const thisSensorString = this_sensor.make+' '+this_sensor.model
                                const thisSensorNameString = this_sensor.make_raw+'-'+this_sensor.model_raw
                                sensorsAvailableString.push(thisSensorString)
                                sensorsAvailableLUT[thisSensorString]=thisSensorNameString
                            });
                        }
                    }
                    //get sensors available from data
                    //sensorsAvailableString = Object.keys(this.props.devices[deviceName].plottableSensorReadings).sort();
                }

                //In a recall of encounter and if the health data is empty
                if(this.props.plotSelectInterface.selectedDevices[plotKey].device_name !== undefined &&
                    this.props.plotSelectInterface.selectedDevices[plotKey].device_name !== '') {
                    //console.log(this.props.plotSelectInterface.selectedDevices[plotKey].device_name)
                    if (!this.props.liveStream && Object.keys(this.originalSelectedDevices).length > 0){
                        Object.keys(this.originalSelectedDevices).forEach(key => {
                            //Check to see if this plot device is the same as the original selected device
                            if( this.props.plotSelectInterface.selectedDevices[plotKey].device_name === this.originalSelectedDevices[key].device_name){
                                const thisSensorDisplayed = this.originalSelectedDevices[key].sensorDisplayed;
                                if(!sensorsAvailableString.find(el => {if(el.includes(thisSensorDisplayed)) return true}))
                                    sensorsAvailableString.unshift(thisSensorDisplayed);
                            }
                        });
                    }
                }
                //Add non-select if missing
                if(!sensorsAvailableString.find(el => {if(el.includes('--')) return true}))
                    sensorsAvailableString.unshift('--');

                let sensorName = this.props.plotSelectInterface.selectedDevices[plotKey].sensorDisplayed;
                const sensorsAvailable = sensorsAvailableString.map((mode,idx) =>
                    <option value={mode} key={mode+'_'+idx+'_sensors'}>{mode}</option>)
                const selectSensorHeader =
                    <select className="modern-skinny" value={sensorName}
                        onChange={(e) => {

                            if(this.props.plotSelectInterface.selectedDevices[plotKey].device_name === undefined)
                                return
                            //this.deviceNameToDisplay = e.target.value;
                            console.log('changing index '+plotKey+' to '+e.target.value)
                            let thisSelectedDevice = JSON.parse(JSON.stringify(this.props.plotSelectInterface.selectedDevices[plotKey]));
                            thisSelectedDevice.sensorDisplayed = e.target.value;
                            thisSelectedDevice.sensor_name = sensorsAvailableLUT[e.target.value];

                            if(thisSelectedDevice.sensorDisplayed.includes('IBAC')){
                                thisSelectedDevice.plot1Displayed = PlottableSensorReading.getDefaultPlot1(PlottableSensorTypes.IBAC);
                                thisSelectedDevice.plot2Displayed = PlottableSensorReading.getDefaultPlot2(PlottableSensorTypes.IBAC);
                            } else if(thisSelectedDevice.sensorDisplayed.includes('TAC7')){
                                thisSelectedDevice.plot1Displayed = PlottableSensorReading.getDefaultPlot1(PlottableSensorTypes.TAC7);
                                thisSelectedDevice.plot2Displayed = PlottableSensorReading.getDefaultPlot2(PlottableSensorTypes.TAC7);
                            } else if(thisSelectedDevice.sensorDisplayed.includes('TACBIO')){
                                thisSelectedDevice.plot1Displayed = PlottableSensorReading.getDefaultPlot1(PlottableSensorTypes.TACBIO);
                                thisSelectedDevice.plot2Displayed = PlottableSensorReading.getDefaultPlot2(PlottableSensorTypes.TACBIO);
                            } else if(thisSelectedDevice.sensorDisplayed.includes('MET')){
                                thisSelectedDevice.plot1Displayed = PlottableSensorReading.getDefaultPlot1(PlottableSensorTypes.MET);
                                thisSelectedDevice.plot2Displayed = PlottableSensorReading.getDefaultPlot2(PlottableSensorTypes.MET);
                            } else if(thisSelectedDevice.sensorDisplayed.includes('ADAv3')){
                                thisSelectedDevice.plot1Displayed = PlottableSensorReading.getDefaultPlot1(PlottableSensorTypes.ADAv3);
                                thisSelectedDevice.plot2Displayed = PlottableSensorReading.getDefaultPlot2(PlottableSensorTypes.ADAv3);
                            } else if(thisSelectedDevice.sensorDisplayed.includes('ADAv5a')){
                                thisSelectedDevice.plot1Displayed = PlottableSensorReading.getDefaultPlot1(PlottableSensorTypes.ADAv5a);
                                thisSelectedDevice.plot2Displayed = PlottableSensorReading.getDefaultPlot2(PlottableSensorTypes.ADAv5a);
                            } else if(thisSelectedDevice.sensorDisplayed.includes('ADAv5b')){
                                thisSelectedDevice.plot1Displayed = PlottableSensorReading.getDefaultPlot1(PlottableSensorTypes.ADAv5b);
                                thisSelectedDevice.plot2Displayed = PlottableSensorReading.getDefaultPlot2(PlottableSensorTypes.ADAv5b);
                            } else if(thisSelectedDevice.sensorDisplayed.includes('CBSIGMA')){
                                thisSelectedDevice.plot1Displayed = PlottableSensorReading.getDefaultPlot1(PlottableSensorTypes.CBSIGMA);
                                thisSelectedDevice.plot2Displayed = PlottableSensorReading.getDefaultPlot2(PlottableSensorTypes.CBSIGMA);
                            } else {
                                thisSelectedDevice.plot1Displayed = '--';
                                thisSelectedDevice.plot2Displayed = '--';
                            }
                            this.props.plotSelectInterface.update(plotKey,thisSelectedDevice)
                            this.forceUpdate();
                        }}>
                        {sensorsAvailable}
                    </select>

                let dataAvailableString:string[] = []
                if(sensorName !== '--'){
                    if(sensorName.includes('IBAC')){
                        dataAvailableString = PlottableSensorReading.getPlottableDataNames(PlottableSensorTypes.IBAC);
                    } else if(sensorName.includes('TAC7')){
                        dataAvailableString = PlottableSensorReading.getPlottableDataNames(PlottableSensorTypes.TAC7);
                    } else if(sensorName.includes('TACBIO')){
                        dataAvailableString = PlottableSensorReading.getPlottableDataNames(PlottableSensorTypes.TACBIO);
                    } else if(sensorName.includes('MET')){
                        dataAvailableString = PlottableSensorReading.getPlottableDataNames(PlottableSensorTypes.MET);
                    } else if(sensorName.includes('ADAv3')){
                        dataAvailableString = PlottableSensorReading.getPlottableDataNames(PlottableSensorTypes.ADAv3);
                    } else if(sensorName.includes('ADAv5a')){
                        dataAvailableString = PlottableSensorReading.getPlottableDataNames(PlottableSensorTypes.ADAv5a);
                    } else if(sensorName.includes('ADAv5b')){
                        dataAvailableString = PlottableSensorReading.getPlottableDataNames(PlottableSensorTypes.ADAv5b);
                    } else if(sensorName.includes('CBSIGMA')){
                        dataAvailableString = PlottableSensorReading.getPlottableDataNames(PlottableSensorTypes.CBSIGMA);
                    }

                }
                dataAvailableString.unshift('--');
                let data1Name = this.props.plotSelectInterface.selectedDevices[plotKey].plot1Displayed;
                const data1Available = dataAvailableString.map((mode,idx) =>
                    <option value={mode} key={mode+'_'+idx+'_data1'}>{mode}</option>)
                const selectData1Header =
                    <select className="modern-skinny green" value={data1Name}
                        onChange={(e) => {
                            //this.deviceNameToDisplay = e.target.value;
                            console.log('changing index '+plotKey+' to '+e.target.value)
                            let thisSelectedDevice = JSON.parse(JSON.stringify(this.props.plotSelectInterface.selectedDevices[plotKey]));
                            thisSelectedDevice.plot1Displayed = e.target.value;
                            this.props.plotSelectInterface.update(plotKey,thisSelectedDevice)
                            this.forceUpdate();
                        }}>
                        {data1Available}
                    </select>
                let data2Name = this.props.plotSelectInterface.selectedDevices[plotKey].plot2Displayed;
                const data2Available = dataAvailableString.map((mode,idx) =>
                    <option value={mode} key={mode+'_'+idx+'_data2'}>{mode}</option>)

                const selectData2Header =
                    <select key={plotKey+plotIdx+'plot2'} className="modern-skinny steelblue" value={data2Name}
                        onChange={(e) => {
                            //this.deviceNameToDisplay = e.target.value;
                            console.log('changing index '+plotKey+' to '+e.target.value)
                            let thisSelectedDevice = JSON.parse(JSON.stringify(this.props.plotSelectInterface.selectedDevices[plotKey]));
                            thisSelectedDevice.plot2Displayed = e.target.value;
                            this.props.plotSelectInterface.update(plotKey,thisSelectedDevice)
                            this.forceUpdate();
                        }}>
                        {data2Available}
                    </select>


                let bioplot;
                if ( bioDataToDisplay !== undefined){
                    bioplot = <BioCountPlotDisplay key={plotKey} plotIndex={plotKey}
                                bioData={bioDataToDisplay[ConvertSensorNameToMakeModel(this.props.plotSelectInterface.selectedDevices[plotKey].sensorDisplayed)]}
                                plot_time_range={plotTimeRange}
                                liveStream={this.props.liveStream}
                                replayTime={this.props.replayTime}
                                plotSelectInterface={this.props.plotSelectInterface}/>;
                }
                //Sensor status message
                let status_string;
                if (deviceName === '--' || sensorName === '--') {
                    status_string = 'Select Node and Sensor'
                } else if (this.props.devices !== undefined && this.props.devices[deviceName] !== undefined){
                    //console.log(deviceName+' '+sensorName+'  ')
                    //console.log(this.props.devices[deviceName])
                    status_string = this.props.devices[deviceName].dataStatus[ConvertSensorNameToMakeModel(sensorName)];
                    //console.log("status_string " + status_string)
                    if(status_string === undefined){
                        status_string = this.props.devices[deviceName].statusString;
                    }
                } else {
                    status_string = 'Loading...'
                }

                const status =
                    <div style={{background:'#282828',position:'relative',bottom:'2px'}}>
                        <div style={{ display: 'flex', position: 'absolute', left: '0px', bottom: '0px', padding: '0px' }}>
                            <label className="dropdown-title">{status_string}</label>
                        </div>
                    </div>
                let loadingIndicator;
                if(bioplot === undefined || bioplot.props.bioData === undefined){
                    if(status_string !== 'Select Node and Sensor' && status_string !== 'No Data Found'){
                        loadingIndicator =
                            <div style={{background:'#282828',position:'relative',bottom:'0px',display:'flex',justifyContent:'center'}}>
                                <div style={{ display: 'flex', position: 'absolute', top: '50px', padding: '0px'}}>
                                    <div className="plotloader"></div>
                                </div>
                            </div>
                    }
                }
                plot =
                    <div key={plotKey+plotIdx} style={{background:'#282828',marginTop:'5px', paddingTop:'3px'}}>
                        <div style={{display:'flex',flexDirection:'row'}}>
                            <label className="dropdown-title">{'Node:'}</label>
                            {selectNodeHeader}
                            <label className="dropdown-title">{'Sensor:'}</label>
                            {selectSensorHeader}
                            <label className="dropdown-title">{' '}</label>
                            {selectData1Header}
                            <label className="dropdown-title">{' '}</label>
                            {selectData2Header}
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',height:'20px'}}>
                                <div className="closebtn" style={{cursor:'pointer'}} onClick={() => this.removeSensorDataPlot(plotKey)}>&times;</div>
                            </div>
                        </div>
                        {loadingIndicator}
                        <div style={{height:'205px', background:'#282828'}}>
                            {bioplot}
                        </div>
                        {status}


                    </div>
                plots.push(plot);

            });
        }

        let add_button;
        if( Object.keys(this.props.plotSelectInterface.selectedDevices).length < 5){
            add_button =
                <div className="add-button-container" style={{display:'contents'}}
                    onClick={() => this.addSensorDataPlot()}>
                <img style={{height:'70px',width:'70px',cursor:'pointer',opacity:'inherit',paddingTop:'6px'}} src={add_icon}/>
                </div>
        }

        return(
            <div className='MultiSensorBioCountDisplay' style={{overflowY:'auto'}}>
                {plots}
                <div style={{display:'flex', justifyContent:'center'}}>
                    {add_button}
                </div>
            </div>

        );
    }

}
